import Swiper from "swiper";
import { A11y, Navigation, Pagination } from "swiper/modules";
import "@styles/components/slider.css";

document.querySelectorAll(".element-testimonials").forEach((el) => {
  const container = el.querySelector(".swiper");

  new Swiper(container, {
    modules: [A11y, Navigation, Pagination],
    slidesPerView: 1,
    spaceBetween: 24,
    speed: 500,
    simulateTouch: false,
    threshold: 25,
    navigation: {
      nextEl: el.querySelector(".slider-button-next"),
      prevEl: el.querySelector(".slider-button-prev"),
    },
    pagination: {
      el: el.querySelector(".slider-pagination"),
      type: "custom",
      renderCustom: (_, current, total) => {
        return `Showing ${current} of ${total}`;
      },
    },
    breakpoints: {
      768: {
        slidesPerView: 2,
      },
      1440: {
        slidesPerView: 3,
      },
    },
  });
});
